import {BudgetEntry} from "@natomas-org/core";

export interface IBudgetSlice {
  [projectId: string]: BudgetEntry[] | null;
}

export const getInitialBudgetSliceState = (): IBudgetSlice => {
  return {};
};
